<template>
  <div style="height: 100%">
    <div class="dialog-content" style="padding-top: 4px;">
      <el-row style="height: 100%;">
        <el-col :span="6" style="padding-right: 4px;">
          <div style="background-color: rgba(41, 155, 255, .1);">
            <el-radio-group v-model="tab" size="small" class="tab">
              <el-radio-button label="按通道"></el-radio-button>
              <!--                <el-radio-button label="按空间"></el-radio-button>-->
            </el-radio-group>
            <div v-if="tab === '按通道'">
              <div class="overflow"
                   style="height: 26vh;overflow: auto;border-bottom: 1px solid rgba(41, 155, 255, .3);">
                <ul style="list-style: none;padding: 15px 6% 20px 6%;" v-if="channelArray.length > 0">
                  <li
                  @touchstart="changePassageway(index)" @click="changePassageway(index)"
                    :style="{backgroundColor : !custom && pageCurrent === (index+1) ? 'rgba(41, 155, 255, .3)' : ''}"
                    class="pointer"
                    :key="index"
                    style="width: 97%;float: left;text-align:center;padding: 5px 10px; border: 1px dashed rgba(41, 155, 255, .3);margin: 0 5px 5px 5px"
                    v-for="(item,index) in Math.ceil(channelArray.length/channel)">
                    通道<a ref="channelNumList">{{ channelArray[index * channel] }}<a v-if="channel !== 1"><a :key="i"
                                                                                                            v-for="i in (channelArray.length-index*channel) < channel ? (channelArray.length-index*channel-1) : (channel-1)">,
                      {{ channelArray[index * channel + i] }}</a></a></a>
                    </li>
                  </ul>
                  <div style="line-height: 20vh;text-align: center;" v-else>暂无数据</div>
                </div>

              <div :class="channel === 1 ? 'oneDiv' :channel === 4 ? 'twoDiv' : 'threeDiv'"
                   class="overflow" style="padding: 20px;overflow: auto">
                <el-switch
                  style="display: inline-block;"
                  v-model="custom"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
                <span style="margin: 5px;">自定义通道</span>
                <el-checkbox-group size="small" style="margin: 20px 2px;" v-if="custom" v-model="checkboxGroup">
                  <el-checkbox :key="index" :label="item"
                               style="width: 35%"
                               @touchstart.native.prevent="checkboxSelect(item,index)"  @click.native.prevent="checkboxSelect(item,index)"
                                 v-for="(item,index) in channelArray">
                      通道{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <div :class="channel === 1 ? 'oneTreeDiv' :channel === 4 ? 'twoTreeDiv' : 'threeTreeDiv'" v-else>
                <space-tree-show @spaceChoose="spaceChoose" class="space" ref="space" style="padding: 10px 25px"/>
              </div>
            </div>
          </el-col>
          <el-col :span="18" style="background-color: rgba(41, 155, 255, .1);padding: 3vh 5vw 2VH 5VW;">
            <span>画面布局：</span>
            <el-select
              @change="initCheckGroup"
              size="mini"
              style="width: 80px;"
              v-model="channel">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in channelList">
              </el-option>
            </el-select>
            <!-- <el-button 
              @click="openPreview" 
              size="mini" 
              type="primary" 
              style="margin-left: 10px;position: absolute;right: 20px;">
              预览
            </el-button> -->
            <div style="text-align: center">
              <ul :class="channel === 1 ? 'oneUl' :channel === 4 ? 'twoUl' : 'threeUl'" class="videoUl"
                  v-if="channels.length > 0">
                <li :class="channel === 1 ? 'one' :channel === 4 ? 'two' : 'three'"
                    :key="item" class="videoLi" v-for="item in channels">
                  <video-component :channel="item" :device-info="deviceInfo" :properties="portProperties"
                                   ref="video"></video-component>
                  <div class="text-right" style="margin: 5px 25px 10px">
                    <span class="float-left" style="color: #299BFF">通道{{ item }}</span>
                    <span @touchstart="openOperation(item)" @click="openOperation(item)" class="pointer">操控
                      <img src="../../assets/images/comprehensive/video_operation.png">
                    </span>
                  </div>
                </li>
              </ul>
              <no-data :class="channel === 1 ? 'oneUl' :channel === 4 ? 'twoUl' : 'threeUl'" class="videoUl"
                       style="padding-top: 20vh" v-else></no-data>
              <div style="text-align: center;display: inline;">
                <el-pagination
                  :page-size="channel"
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pageCurrent"
                  :total="checkboxGroup.length"
                  v-if="custom && channelArray.length > 0">
                </el-pagination>
                <div style="height: 3.3vh" v-else></div>
              </div>
            </div>
          </el-col>
        </el-row>
    </div>

    <!--    弹出窗-->
    <dialog-component
      :dialog-title="title"
      :dialogVisible.sync="videoFullScreenVisible"
      @dialogClose="closeDialog"
      center
      width="80vw"
      append-to-boby>
      <div slot="content" style="height: 74vh;">
        <video-full-screen :deviceInfo="deviceInfo"
                           :selectChannel="selectChannel"
                           :properties="portProperties" />
      </div>
    </dialog-component>

  </div>
</template>

<script>
import VideoComponent from "@/components/video/VideoComponent";
import VideoFullScreen from "@/components/video/VideoFullScreen";
import {getDeviceInfo} from "@/network/device-info";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import {getDVRInfo} from "@/network/DVR";
import NoData from "@/components/NoData";
import DialogComponent from "@/components/DialogComponent";

export default {
  name: "DVR",
  components: {VideoComponent, DialogComponent, VideoFullScreen, SpaceTreeShow, NoData},
  props: ['deviceInfo'],
  inject: ['overflow'],
  mounted() {
    this.overflow();
    this.getDeviceInfo();
  },
  data() {
    return {
      show: 1,
      tab: "按通道",
      portProperties: null,
      activeName: 'first',
      channel: 1, //布局数
      channelList: [{
        id: 1,
        name: "1x1",
      }, {
        id: 4,
        name: "2x2",
      }],
      channelArray: [],
      pageTotal: 0,
      pageCurrent: 1, //当前页
      channels: [], //当前页的通道
      custom: false, //自定义通道
      checkboxGroup: [1], //自定义通道复选框
      videoFullScreenVisible: false, //视屏全屏显示
      title: "",
      selectChannel: null, //选中的摄像头的通道
      spaceId: null,
      spaceName: null,
      // 首次进入
      isLoad: true,

    }
  },
  watch: {
    custom: {
      handler() {
        this.initCheckGroup()
      }
    }
  },
  methods: {
    getDeviceInfo() {
      getDeviceInfo(this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.portProperties = JSON.parse(res.data.portProperties)
          this.getDVRInfo();
        }
      })
    },
    //获取视频通道信息
    getDVRInfo() {
      if (this.portProperties) {
        getDVRInfo("hikvision", this.portProperties.User, this.portProperties.pwd, this.portProperties.IP).then(res => {
          if (res.code === 0) {
            const chanNum = res.data.chanNum
            const startChan = res.data.startChan
            // const dwDChanNum = res.data.dwDChanNum
            // const dwStartDChan = res.data.dwStartDChan
            const dvrDeviceChanInfos = res.data.dvrDeviceChanInfos
            this.channelArray = []
            if (chanNum && chanNum > 0) {
              for (let i = startChan; i < startChan + chanNum; i++) {
                this.channelArray.push(i)
              }
            }
            // if (dwDChanNum > 0) {
            //   for (let i = dwStartDChan; i < dwStartDChan + dwDChanNum; i++) {
            //     this.channelArray.push(i)
            //   }
            // }
            if (dvrDeviceChanInfos && dvrDeviceChanInfos.length > 0) {
              dvrDeviceChanInfos.forEach(item => {
                if (item.byChannel !== 0) {
                  this.channelArray.push(item.byIPID)
                }
              })
            }
            console.log(this.channelArray, "=====this.channelArray======");
            this.initCheckGroup()
          }
        })
      }
    },
    //初始化通道和布局
    initCheckGroup() {
      this.pageCurrent = 1;
      this.channels = []
      this.checkboxGroup = []
      if (this.channelArray.length > this.channel - 1) {
        for (let i = 0; i < this.channel; i++) {
          this.checkboxGroup.push(this.channelArray[i])
          this.channels.push(this.channelArray[i])
        }
      } else {
        this.channels = this.channelArray
        this.checkboxGroup = this.channelArray
      }
    },
    //分页按钮事件
    handleCurrentChange(val) {
      this.pageCurrent = val;
      if (this.custom) {
        if (this.channel !== 1) {
          //通道
          const startIndex = (val - 1) * this.channel;
          const endIndex = (val - 1) * this.channel + this.channel > this.channelArray.length ? this.channelArray.length : (val - 1) * this.channel + this.channel
          const group = this.checkboxGroup.slice(startIndex, endIndex);
          console.log(startIndex, endIndex, group, this.checkboxGroup);
          this.channels = []
          for (let i = 0; i < group.length; i++) {
            this.channels.push(group[i])
          }
        }
      }

    },
    //视屏操控弹框
    openOperation(channel) {
      this.title = "通道" + channel;
      this.selectChannel = channel;
      this.videoFullScreenVisible = true;
      console.log(channel);
    },
    //通道选择
    changePassageway(index) {
      const array = this.$refs.channelNumList[index].innerText.replace(/\s/g, '').split(",")
      let dataIntArr = []
      dataIntArr = array.map(item => {
        return +item;
      });
      console.log(dataIntArr);
      if (!this.custom) {
        this.channels = dataIntArr
        //选择框背景色改变
        this.handleCurrentChange(index + 1)
      }
    },
    //自定义通道选择
    checkboxSelect(item, index) {
      if (this.custom) {
        if (this.channel === 1) {
          this.channels = [item]
          this.checkboxGroup = [item]
          this.handleCurrentChange(index + 1)
        } else {
          //复选框选择和反选
          let flag = true;
          this.checkboxGroup.forEach((check, index) => {
            if (check === item) {
              this.checkboxGroup.splice(index, 1)
              flag = false;
            }
          })
          if (flag) {
            this.checkboxGroup.unshift(item)
          }
          //通道
          this.handleCurrentChange(1)
        }
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1));
    },
    //空间树选择
    spaceChoose(spaceInfo) {
      if (this.isLoad) {
        this.isLoad = false;
        this.$refs.space.ztreeObj.selectNode([]);
      } else {
        if (spaceInfo.type !== 1) {
          this.spaceId = spaceInfo.id;
          this.spaceName = spaceInfo.title;
        } else {
          this.$message.error('此空间为逻辑空间,无法选择');
          this.spaceId = null;
          this.spaceName = null;
          this.$refs.space.ztreeObj.selectNode([]);
        }
      }
    },

    //关闭
    closeDialog(){
      this.videoFullScreenVisible = false;
    },
    
    // //打开预览页面
    // openPreview() {
    //   window.open('http://192.168.75.2', '_blank');
    // },
  }
}
</script>

<style scoped>

.videoUl {
  margin: auto;
  padding: 3vh 0;
}

.videoLi {
  float: left;
  list-style: none;
  border: 1px solid #fff;
  margin: 0 2% 20px 0;
  background-color: rgba(41, 155, 255, .1);
}

.oneDiv {
  height: 29.6vh;
}

.oneTreeDiv {
  height: 55.6vh;
}

.oneUl {
  width: 99%;
  min-height: 48.3vh;
}

.one {
  width: 94%;
}

.twoDiv {
  height: 35.2vh;
}

.twoTreeDiv {
  height: 61.3vh;
}

.twoUl {
  width: 100%;
  height: 54vh;
}

.two {
  width: 45%;
  min-height: 215px;;
}

.threeDiv {
  height: 39.3vh;
}

.threeTreeDiv {
  height: 65.3vh;
}

.threeUl {
  width: 100%;
  height: 58vh;
}

.three {
  width: 28.2%;
  min-height: 155px;;
}

.tab.el-radio-group >>> .el-radio-button.el-radio-button--small {
  width: 100% !important;
}

.tab.el-radio-group, .tab.el-radio-group >>> .el-radio-button__inner {
  width: 100%;
}

.el-checkbox >>> .el-checkbox__input .el-checkbox__inner {
  background-color: transparent;
}

.el-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409EFF;
}
</style>
